export const LoadingPlaces = () => {
  return (
    <div className="alert alert-primary">
      <h6>Searching</h6>
      <p>Please, wait...</p>
    </div>
  );
};
